<ion-button fill="clear" (click)="onExchange()">
  <fa-icon [icon]="faExchange" class="exchange-icon exchange-icon__exchange"></fa-icon>
</ion-button>
